export enum CreditScoreStatuses {
  AUTHENTICATION_INITIATED = 'AUTHENTICATION_INITIATED',
  AUTHENTICATION_COMPLETED = 'AUTHENTICATION_COMPLETED',
  AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED',
  REGISTRATION_COMPLETED = 'REGISTRATION_COMPLETED',
  REGISTRATION_FAILED = 'REGISTRATION_FAILED',
  CREDIT_REPORT_RECEIVED = 'CREDIT_REPORT_RECEIVED',
}

export const CREDIT_SCORE_PROVIDER_ID_EQUIFAX = 2;
